// @ts-nocheck
/* eslint-disable */
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SUREnet overig API
 * OpenAPI spec version: 1
 */
import { useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { unref } from 'vue';

import type { CollectionResultOfSUREbusinessManagementLandenGetLandenLandDto } from '../model/collectionResultOfSUREbusinessManagementLandenGetLandenLandDto.ts';

import { customInstance } from '../../customInstance.ts';
import type { ErrorType } from '../../customInstance.ts';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Haal alle landen op
 */
export const landenGetLanden = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<CollectionResultOfSUREbusinessManagementLandenGetLandenLandDto>(
    { url: `/api/v1/landen`, method: 'GET', signal },
    options,
  );
};

export const getLandenGetLandenQueryKey = () => {
  return ['api', 'v1', 'landen'] as const;
};

export const getLandenGetLandenQueryOptions = <
  TData = Awaited<ReturnType<typeof landenGetLanden>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof landenGetLanden>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getLandenGetLandenQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof landenGetLanden>>> = ({ signal }) =>
    landenGetLanden(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof landenGetLanden>>,
    TError,
    TData
  >;
};

export type LandenGetLandenQueryResult = NonNullable<Awaited<ReturnType<typeof landenGetLanden>>>;
export type LandenGetLandenQueryError = ErrorType<unknown>;

/**
 * @summary Haal alle landen op
 */

export function useLandenGetLanden<
  TData = Awaited<ReturnType<typeof landenGetLanden>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof landenGetLanden>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getLandenGetLandenQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}
